module.exports = {
    FIREBASE_CONFIG: {
        apiKey: "AIzaSyDjj392u9tTfk-0A_7FPZdmf940pflLcy0",
        authDomain: "buidlbox-lite.firebaseapp.com",
        databaseURL: "https://buidlbox-lite.firebaseio.com",
        projectId: "buidlbox-lite",
        storageBucket: "buidlbox-lite.appspot.com",
        messagingSenderId: "427530799422"
    },
};
    


// WEBPACK FOOTER //
// ./src/settings/Firebase/index.js